module.exports = __webpack_public_path__ + "static/chunks/src/components/part-header/assets/logo-vissa-main.1c0c76c6d059c6821577aaea2fa860a4.webp";